import React, { useContext, useState } from 'react'
import { Popover } from '@headlessui/react'
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline'
import { AuthContext } from "../contexts/auth"
import { createDipendente, changeAppEnable } from '../services/api'
import { DynamicForm } from "../components/form/dyanmic_form";
import BackButton from "../components/back_button";
import Swal from 'sweetalert2'
import Footer from "../components/footer";
import UploadUnilavEmployee from "../components/modal_upload_unilav";
import { Link } from 'wouter';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import OnBoarding from '../components/on_boarding';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PopoverComponentCustom from '../components/popover_component'


export default function NewEmployee() {
  const { profile, token } = useContext(AuthContext)

  const [loading, setLoading] = useState(false)
  const [showModalUploadUnilav, setShowModalUploadUnilav] = useState(false);
  const [showOnBoarding, setShowOnBoarding] = useState(false);
  const [showDynamicForm, setShowDynamicForm] = useState(false);
  const [addingEmployees, setAddingEmployees] = useState(false);

  const isProfileComplete = profile.has_complete_profile;

  const fields = [
    { type: 'text', label: 'Nome', name: 'first_name', required: true },
    { type: 'text', label: 'Cognome', name: 'last_name', required: true },
    { type: 'text', label: 'Codice Fiscale', name: 'tax_code', required: true },
    { type: 'text', label: 'Email', name: 'email',  required: true },
    // { type: 'checkbox', label: 'Agree to terms', name: 'terms' },
    // { type: 'select', label: 'Favorite color', name: 'color', options: ['Red', 'Green', 'Blue'] },
    // { type: 'radio', label: 'Gender', name: 'gender', options: ['Male', 'Female'] },
    // { type: 'number', label: 'Age', name: 'age' },
  ];

  const [initialValues, setInitialValues] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const hasConsultalaHRPro = profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro");

  const handleSubmit = async (e, values) => {
    e.preventDefault();
    setLoading(true);
    setIsSaving(true);
    // TODO: 
    // set loading
    // send data to api
    try {
      await createDipendente(token, values);
      setLoading(false);
      setIsSaving(false);

      Swal.fire({
        title: 'Dipendente Creato!',
        html: `
          <div>
            <p>Creazione del dipendente andata a buon fine.</p>
            <p>Vuoi abilitare l'accesso all'app?</p>
          </div>
        `,
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Sì, abilita ora',
        cancelButtonText: 'No',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          handleAppStatusChange(values.tax_code);
        } else {
          window.location.href = `/dipendenti`;
        }
      });
      setInitialValues({});
    } catch (error) {
      setLoading(false);
      setIsSaving(false);
      console.log(error);
      Swal.fire({
        title: 'Errore!',
        text: 'Errore durante la creazione: ' + error.response.data,
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  const handleAppStatusChange = async (employeeCf) => {
    Swal.fire({
      title: 'Attendere...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  
    try {
      await changeAppEnable(token, employeeCf, 'activate');
  
      Swal.fire({
        icon: 'success',
        title: 'Salvato!',
        text: "L'accesso all'app è stato attivato!",
        confirmButtonText: 'OK',
      }).then(() => {
        Swal.fire({
          title: 'Vuoi proseguire inserendo i dati del contratto del dipendente?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sì, vai all\'inserimento contratto',
          cancelButtonText: 'No',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = `/dipendenti/${employeeCf}/edit?tab=2`;
          } else {
            window.location.href = `/dipendenti`;
          }
        });
      })
    } catch (error) {
      console.error('Errore nel cambio dello stato dell\'app:', error);

      let errorMessage = 'Si è verificato un errore durante l\'abilitazione dell\'accesso all\'app.';

      if (!error.response) {
        errorMessage = 'Errore, riprova più tardi.';
      } else if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });

        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      }).then(() => {
        window.location.href = `/dipendenti/${employeeCf}`;
      });
    }
  };
  
  
  return <>
    <div className="flex flex-col min-h-screen">
      <PopoverComponentCustom title="Aggiungi Dipendente" />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="flex-grow">
        <div className="mx-auto max-w-3xl lg:max-w-7xl">
          {/* back button */}

          {!addingEmployees && (
            <div className="flex items-center justify-between my-4 px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-8">
              <BackButton prevLocation="/dipendenti" />
                
                {/* <button type="button" className="ml-4 block rounded-md bg-purple-400 px-3 py-2 text-center text-sm font-semibold text-purple-800 shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600"
                  onClick={() => {}}
                >
                  Aggiorna
                </button> */}
              
              {/* a div with a fake table */}
              {/* <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="flex w-full justify-between bg-sky-700 px-4 py-4 text-left text-sm font-medium text-white">
                  <span>DATI ACCESSO APP</span>
                </div>
                <DynamicForm fields={fields} handleSubmit={handleSubmit} initialValues={initialValues}/>
              </div> */}
            </div>
          )}
    
          {/* a div with a fake table */}

          {!addingEmployees && (
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 rounded-lg pb-12 px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-12">
              {/* Creazione multipla */}
              <div 
                className="border border-gray-200 rounded-lg p-4 shadow-lg cursor-pointer transition duration-300 hover:-translate-y-2 hover:scale-105 hover:bg-indigo-50 flex flex-col justify-between"
                onClick={() => {
                  setShowOnBoarding(true);
                  setAddingEmployees(true);
                }}
              >
                <p className="font-semibold text-xl pt-4 text-indigo-800 text-center">
                  Creazione multipla da form <br /> (Attivazione rapida dipendenti e app)
                </p>
                <div className='mt-auto'>
                  <div className="flex justify-center pt-6 pb-4">
                    <div className="bg-indigo-200 rounded-full w-24 h-24 flex items-center justify-center">
                      <GroupAddIcon style={{ width: '2.5rem', height: '2.5rem', color: '#3730A3' }} />
                    </div>
                  </div>
                  <div className='h-28 flex items-center'>
                    <p className='text-xs text-indigo-800 px-6 text-center'>Compila i dati essenziali dell'anagrafica e del contratto per la creazione e attivazione di uno o più dipendenti</p>
                  </div>
                </div>
              </div>

              {/* Creazione singolo dip da form */}
              <div 
                className="border border-gray-200 rounded-lg p-4 shadow-lg cursor-pointer transition duration-300 hover:-translate-y-2 hover:scale-105 hover:bg-indigo-50 flex flex-col justify-between"
                onClick={() => {
                  setShowDynamicForm(true);
                  setAddingEmployees(true);
                }}
              >
                <p className="font-semibold text-xl pt-4 text-indigo-800 text-center">
                  Creazione dipendente da form
                </p>
                <div className='mt-auto'>
                  <div className="flex justify-center pt-6 pb-4">
                    <div className="bg-indigo-200 rounded-full w-24 h-24 flex items-center justify-center">
                      <PersonAddIcon style={{ width: '2.5rem', height: '2.5rem', color: '#3730A3' }} />
                    </div>
                  </div>
                  <div className='h-28 flex items-center'>
                    <p className='text-xs text-indigo-800 px-6 text-center '>Compila i dati del dipendente e prosegui con la creazione del contratto</p>
                  </div>
                </div>
              </div>
              
              {/* Creazione da Unilav */}
              <div 
                className="border border-gray-200 rounded-lg p-4 shadow-lg cursor-pointer transition duration-300 hover:-translate-y-2 hover:scale-105 hover:bg-indigo-50 flex flex-col justify-between"
                onClick={() => setShowModalUploadUnilav(true)}
              >
                <p className="font-semibold text-xl pt-4 text-indigo-800 text-center">
                  Carica Unilav
                </p>
                <div className='mt-auto'>
                  <div className="flex justify-center items-bottom pt-6 pb-4">
                    <div className="bg-indigo-200 rounded-full w-24 h-24 flex items-center justify-center">
                      <UploadFileIcon style={{ width: '2.5rem', height: '2.5rem', color: '#3730A3' }} />
                    </div>
                  </div>
                  <div className='h-28 flex items-center'>
                    <p className='text-xs text-indigo-800 px-6 text-center'>Carica il file Unilav (pdf o xml) per creare automaticamente il dipendente e il contratto</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {showDynamicForm && (
            <div className='px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-12'>
              <DynamicForm 
                fields={fields} 
                handleSubmit={handleSubmit} 
                initialValues={initialValues} 
                isSaving={isSaving} 
                addingEmployees={addingEmployees}
                onComplete={() => {
                  setShowDynamicForm(false);
                  setAddingEmployees(false);
                }}
              />
            </div>
          )}

          {showOnBoarding && addingEmployees && (
            <OnBoarding
              token={token}
              addingEmployees={addingEmployees}
              onComplete={() => {
                setShowOnBoarding(false);
                setAddingEmployees(false);
              }}
            />
          )}

        </div>
      </main>
      <Footer />
      {showModalUploadUnilav && (
        <UploadUnilavEmployee closeModalUploadUnilav={() => setShowModalUploadUnilav(false)}/>
      )}
    </div>
  </>;
}